const toCsvSafe = (value) => {
  const raw = value === null || value === undefined ? '' : String(value)
  const escaped = raw.replace(/"/g, '""')
  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped
}

const toDate = (input) => {
  if (!input) return null

  if (Array.isArray(input)) {
    const [year, month, day, hour = 0, minute = 0, second = 0, nanosecond = 0] =
      input
    const parsed = new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        hour,
        minute,
        second,
        Math.floor(nanosecond / 1000000)
      )
    )
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }

  if (typeof input === 'string') {
    const parsed = new Date(input)
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }

  return null
}

const formatDateTime = (input) => {
  const parsed = toDate(input)
  if (!parsed) return ''
  return parsed.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })
}

const formatAmount = (amount, currency = 'AED') => {
  const value = Number(amount)
  if (!Number.isFinite(value)) return ''
  return `${currency} ${value.toFixed(2)}`
}

export const exportAdminSubscriptionsToCSV = (
  subscriptions,
  filename = 'admin_subscriptions'
) => {
  if (!Array.isArray(subscriptions) || subscriptions.length === 0) {
    throw new Error('No subscriptions to export')
  }

  const headers = [
    'Subscription ID',
    'Purchased At',
    'User Name',
    'User Email',
    'Plan Name',
    'Plan Code',
    'Status',
    'Start Date',
    'End Date',
    'Amount',
    'Recurring',
    'Auto Renew',
    'Countries',
    'Cancellation Reason',
  ]

  const rows = subscriptions.map((item) => [
    item?.id || '',
    formatDateTime(item?.purchasedAt),
    item?.userName || '',
    item?.userEmail || '',
    item?.planName || '',
    item?.planCode || '',
    item?.status || '',
    formatDateTime(item?.startDate),
    formatDateTime(item?.endDate),
    formatAmount(item?.amountPaid, item?.currency || 'AED'),
    item?.isRecurring ? 'Yes' : 'No',
    item?.autoRenew ? 'Yes' : 'No',
    Array.isArray(item?.countries) ? item.countries.join('; ') : '',
    item?.cancellationReason || '',
  ])

  const csvLines = [
    headers.map(toCsvSafe).join(','),
    ...rows.map((row) => row.map(toCsvSafe).join(',')),
  ]

  const blob = new Blob([csvLines.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute(
    'download',
    `${filename}_${new Date().toISOString().slice(0, 10)}.csv`
  )
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
